import { useCallback, useMemo } from "react";

import { useHookOption } from "@features/errors/hooks/use-hook-option.ts";
import { type MessageDescriptor, useIntl } from "react-intl";

import { allValidationMessages } from "@shared/libs/validators/i18n/validation-error-codes.ts";

export const useFormatErrorMessages = <
  T extends string,
  U extends Record<T, MessageDescriptor>,
>(
  messages: U[] = [],
) => {
  const { formatMessage } = useIntl();
  const messagesOption = useHookOption(messages);

  const messageMap = useMemo<Map<string, MessageDescriptor>>(() => {
    const messageDescriptors: MessageDescriptor[] = [
      ...messagesOption.current,
      ...allValidationMessages,
    ].flatMap((group) => Object.values(group));
    const map = new Map<string, MessageDescriptor>();

    for (const descriptor of messageDescriptors) {
      if (descriptor.id) {
        map.set(descriptor.id, descriptor);
      }
    }
    return map;
  }, [messagesOption]);

  return useCallback(
    (id?: string, payload?: Record<string, any>) => {
      if (!id) {
        return formatMessage({
          id: "validator.unknow",
          defaultMessage: "Неверное значение",
        });
      }

      const messageDescriptor = messageMap.get(id);
      if (!messageDescriptor) {
        return formatMessage({
          id: "validator.unknow",
          defaultMessage: "Неверное значение",
        });
      }
      return formatMessage(messageDescriptor, payload);
    },
    [formatMessage, messageMap],
  );
};
